export default __webpack_public_path__ + "static/7-e81bb0c730a1239bde41177ae4514641.png";